import { createUploadStartBIData, createUploadEndBIData } from './mediaUploadBI.js';
import 'wix-rich-content-common/libs/uuid';

var version = "9.16.7";

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const applyBIGenerics = (getContentId) => (_a) => {
  var _b = _a, { helpers = {} } = _b, rest = __objRest(_b, ["helpers"]);
  return __spreadProps(__spreadValues({}, rest), {
    helpers: __spreadProps(__spreadValues({}, helpers), {
      // Editor
      onPluginAdd: (pluginId, entryPoint) => {
        var _a2;
        return (_a2 = helpers.onPluginAdd) == null ? void 0 : _a2.call(helpers, pluginId, entryPoint, version, getContentId());
      },
      onPluginAddStep: (args) => {
        var _a2;
        return (_a2 = helpers.onPluginAddStep) == null ? void 0 : _a2.call(helpers, __spreadProps(__spreadValues({}, args), { version, contentId: getContentId() }));
      },
      onPluginsPopOverTabSwitch: (args) => {
        var _a2;
        return (_a2 = helpers.onPluginsPopOverTabSwitch) == null ? void 0 : _a2.call(helpers, __spreadProps(__spreadValues({}, args), { version, contentId: getContentId() }));
      },
      onPluginsPopOverClick: (args) => {
        var _a2;
        return (_a2 = helpers.onPluginsPopOverClick) == null ? void 0 : _a2.call(helpers, __spreadProps(__spreadValues({}, args), { version, contentId: getContentId() }));
      },
      onChangePluginSettings: (args) => {
        var _a2;
        return (_a2 = helpers.onChangePluginSettings) == null ? void 0 : _a2.call(helpers, __spreadProps(__spreadValues({}, args), { version, contentId: getContentId() }));
      },
      mediaPluginsDetails: (args) => {
        var _a2;
        return (_a2 = helpers.mediaPluginsDetails) == null ? void 0 : _a2.call(helpers, __spreadProps(__spreadValues({}, args), { version, contentId: getContentId() }));
      },
      onPluginAddSuccess: (pluginId, entryPoint, params) => {
        var _a2;
        return (_a2 = helpers.onPluginAddSuccess) == null ? void 0 : _a2.call(helpers, pluginId, entryPoint, params, version, getContentId());
      },
      onMediaUploadStart: (...args) => {
        var _a2;
        const {
          correlationId,
          pluginId,
          fileSize,
          mediaType,
          timeStamp
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
        } = createUploadStartBIData(...args);
        (_a2 = helpers.onMediaUploadStart) == null ? void 0 : _a2.call(
          helpers,
          correlationId,
          pluginId,
          fileSize,
          mediaType,
          version,
          getContentId()
        );
        return { correlationId, pluginId, fileSize, mediaType, timeStamp };
      },
      onMediaUploadEnd: (...args) => {
        var _a2;
        const {
          correlationId,
          pluginId,
          duration,
          fileSize,
          mediaType,
          isSuccess,
          errorType
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
        } = createUploadEndBIData(...args);
        (_a2 = helpers.onMediaUploadEnd) == null ? void 0 : _a2.call(
          helpers,
          correlationId,
          pluginId,
          duration,
          fileSize,
          mediaType,
          isSuccess,
          errorType,
          version,
          getContentId()
        );
      },
      onPluginAction: (eventName, params) => {
        var _a2;
        return (_a2 = helpers.onPluginAction) == null ? void 0 : _a2.call(helpers, eventName, __spreadProps(__spreadValues({}, params), {
          version,
          contentId: getContentId()
        }));
      },
      onPluginChange: (pluginId, changeObj) => {
        var _a2;
        return (_a2 = helpers.onPluginChange) == null ? void 0 : _a2.call(helpers, pluginId, changeObj, version, getContentId());
      },
      onToolbarButtonClick: (args) => {
        var _a2;
        return (_a2 = helpers.onToolbarButtonClick) == null ? void 0 : _a2.call(helpers, __spreadProps(__spreadValues({}, args), { version, contentId: getContentId() }));
      },
      onInlineToolbarOpen: (args) => {
        var _a2;
        return (_a2 = helpers.onInlineToolbarOpen) == null ? void 0 : _a2.call(helpers, __spreadProps(__spreadValues({}, args), { version, contentId: getContentId() }));
      },
      onPluginModalOpened: (args) => {
        var _a2;
        return (_a2 = helpers.onPluginModalOpened) == null ? void 0 : _a2.call(helpers, __spreadProps(__spreadValues({}, args), { version, contentId: getContentId() }));
      },
      onMenuLoad: (args) => {
        var _a2;
        (_a2 = helpers.onMenuLoad) == null ? void 0 : _a2.call(helpers, __spreadProps(__spreadValues({}, args), { version, contentId: getContentId() }));
      },
      // Viewer
      onViewerLoaded: (args) => {
        var _a2;
        return (_a2 = helpers.onViewerLoaded) == null ? void 0 : _a2.call(helpers, __spreadProps(__spreadValues({}, args), { version, contentId: getContentId() }));
      },
      onViewerAction: (pluginId, actionName, value) => {
        var _a2;
        return (_a2 = helpers.onViewerAction) == null ? void 0 : _a2.call(helpers, pluginId, actionName, value, getContentId());
      }
    })
  });
};

export { applyBIGenerics };
//# sourceMappingURL=applyGenericParams.js.map
